// extracted by mini-css-extract-plugin
module.exports = {"createFolderForm":"createFolderForm__C5GDR","inputWrapper":"inputWrapper__2gq6F","tooltip":"tooltip__FovaD","input":"input__ZExat","button":"button__zvwLX"};